'use client'

import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Flex } from '@chakra-ui/react'
import { useRouter } from 'next/navigation'

import { Input } from 'components/form/Input'
import { InputWithButton } from 'components/form/InputWithButton'
import { Button } from 'components/ui/Buttons/Button'

import { StyledForm } from './styles'

const HeroSearch = (): JSX.Element => {
  const [searchTerm, setSearchTerm] = useState('')
  const { t } = useTranslation(['homepage', 'common'])
  const router = useRouter()

  const handleSearch = () => {
    if (searchTerm === '') {
      router.push('/browse')
    } else {
      router.push(`/browse?searchTerm=${searchTerm}&location=&category=`)
    }
  }

  return (
    <Flex>
      <Box display={{ base: 'block', md: 'none' }} width="100%">
        <InputWithButton
          placeholder={t('common:searchInputPlaceholder')}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          name="searchProductWithButton"
          onClick={handleSearch}
        />
      </Box>
      <StyledForm
        onSubmit={(e) => {
          e.preventDefault()
          handleSearch()
        }}
      >
        <Box width="100%">
          <Input
            placeholder={t('common:searchInputPlaceholder')}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            name="searchProduct"
            label={t('common:searchInputPlaceholder')}
            className="gtm-search-input"
          />
        </Box>
        <Box marginLeft="20px" width="100px">
          <Button onClick={handleSearch}>{t('common:search')}</Button>
        </Box>
        <Box width="180px" marginLeft="20px">
          <Button href="/browse">{t('common:seeAllProducts')}</Button>
        </Box>
      </StyledForm>
    </Flex>
  )
}

export default HeroSearch
